import React, { useState } from 'react';
import './Pets.css';

const pets = {
  common: [
    {
      name: 'Starfish',
      image: '/images/pets/StarfishIcon.webp',
      ability: 'Generates passive XP (~6 XP/sec, increases with age)',
      hatchChance: '50%',
      description: 'Gives passive XP while online. Rate increases as the pet levels up.'
    },
    {
      name: 'Crab',
      image: '/images/pets/CrabIcon.webp',
      ability: 'Visits other players to pinch Sheckles (every ~6 min)',
      hatchChance: '25%',
      description: 'Periodically earns Sheckles by pinching nearby players.'
    },
    {
      name: 'Seagull',
      image: '/images/pets/SeagullIcon.webp',
      ability: 'Chance to drop a seed when shoveling a plant (not fruits)',
      hatchChance: '25%',
      description: 'Occasionally finds seeds while you shovel plants.'
    },
    {
      name: 'Bunny',
      image: '/images/pets/BunnyPet.webp',
      ability: 'Eats carrot every 40s and sells it at 1.5× value (scales with age)',
      hatchChance: '33.33%',
      description: 'Consumes carrots or chocolate carrots for profit.'
    },
    {
      name: 'Dog',
      image: '/images/pets/DogPet.webp',
      ability: 'Every 60s, has a 5% chance to dig up a random seed',
      hatchChance: '33.33%',
      description: 'Digs up basic seeds from the shop every now and then.'
    },
    {
      name: 'Golden Lab',
      image: '/images/pets/GoldenLabPet.webp',
      ability: '10% chance every 60s to dig up a random seed (scales with age)',
      hatchChance: '33.33%',
      description: 'An upgraded dog with higher dig chances and better rewards.'
    }
  ],
    uncommon: [
    {
      name: 'Bee',
      image: '/images/pets/Beee.webp',
      ability: 'Pollinates a nearby crop every 20 minutes',
      hatchChance: '20%',
      description: 'Applies the Pollinated mutation to nearby fruits.'
    },
    {
      name: 'Black Bunny',
      image: '/images/pets/Black_bunny_icon.webp',
      ability: 'No special ability',
      hatchChance: '20%',
      description: 'A dark-colored bunny with no passive effect.'
    },
    {
      name: 'Cat',
      image: '/images/pets/Catpet.webp',
      ability: 'Every 80s, causes nearby fruits to grow 1.25× larger',
      hatchChance: '20%',
      description: 'Takes naps and boosts fruit size nearby.'
    },
    {
      name: 'Chicken',
      image: '/images/pets/Chicken_Pet_V2.webp',
      ability: 'Increases hatch speed of pet eggs by 10%',
      hatchChance: '20%',
      description: 'Helps other pets hatch faster.'
    },
    {
      name: 'Deer',
      image: '/images/pets/Deer.webp',
      ability: '10% chance that berries don’t disappear on harvest',
      hatchChance: '20%',
      description: 'Preserves berry plants after harvesting.'
    }
  ],
    rare: [
    {
      name: 'Monkey',
      image: '/images/pets/Monkey_Pet_V2.webp',
      ability: 'Chance to refund the fruit’s seed when selling it',
      hatchChance: '7.14%',
      description: 'Occasionally returns your seed when you sell a fruit.'
    },
    {
      name: 'Orange Tabby',
      image: '/images/pets/Orange_tabby_icon.webp',
      ability: 'Every 90 s, naps for 15 s; new nearby fruits grow 1.5× larger',
      hatchChance: '7.14%',
      description: 'An orange-striped cat that boosts fruit growth during naps.'
    },
    {
      name: 'Pig',
      image: '/images/pets/Pig_no_back.webp',
      ability: 'Every ~118 s, creates a 15 s aura doubling mutation chance of nearby plants',
      hatchChance: '7.14%',
      description: 'Oinks to greatly increase mutation odds for a short time.'
    },
    {
      name: 'Rooster',
      image: '/images/pets/Rooster.webp',
      ability: 'Increases hatch speed of all pet eggs by 20%',
      hatchChance: '7.14%',
      description: 'Helps your eggs mature faster.'
    },
    {
      name: 'Spotted Deer',
      image: '/images/pets/Spotteddeer.webp',
      ability: '10% chance that harvested berry plants remain',
      hatchChance: '7.14%',
      description: 'A rare deer that helps berry plants auto-regrow.'
    },
    {
      name: 'Flamingo',
      image: '/images/pets/FlamingoIcon.webp',
      ability: 'Every 4 min, for 15 s all nearby plants grow ~15× faster',
      hatchChance: '7.14%',
      description: 'Pink and fabulous—it triggers massive growth bursts.'
    },
    {
      name: 'Toucan',
      image: '/images/pets/ToucanIcon.webp',
      ability: 'Boosts size and variant chance of tropical fruits nearby',
      hatchChance: '7.14%',
      description: 'A colorful bird that enhances tropical harvests.'
    },
    {
      name: 'Sea Turtle',
      image: '/images/pets/SeaTurtleIcon.webp',
      ability: 'Every 10 min, grants 1000 XP to a random active pet',
      hatchChance: '7.14%',
      description: 'Shares ancient wisdom to level up your pets.'
    },
    {
      name: 'Orangutan',
      image: '/images/pets/OrangutanIcon.webp',
      ability: 'Chance to not consume materials when crafting',
      hatchChance: '7.14%',
      description: 'Makes crafting more efficient with material refunds.'
    },
    {
      name: 'Seal',
      image: '/images/pets/SealIcon.webp',
      ability: 'Chance to refund its egg when you sell this pet',
      hatchChance: '7.14%',
      description: 'A playful seal that sometimes swims back into its egg.'
    },
    {
      name: 'Honey Bee',
      image: '/images/pets/HoneyBee.webp',
      ability: 'Pollinates nearby fruits every ~20 min (faster than regular Bee)',
      hatchChance: '7.14%',
      description: 'Produces sweeter pollen to trigger the Pollinated mutation.'
    },
    {
      name: 'Wasp',
      image: '/images/pets/The_Wasp.webp',
      ability: 'No gameplay effect (purely cosmetic)',
      hatchChance: '7.14%',
      description: 'A feisty insect—watch the sting animation, but it does nothing.'
    },
    {
      name: 'Hedgehog',
      image: '/images/pets/HedgehogPet.webp',
      ability: 'No gameplay effect (purely cosmetic)',
      hatchChance: '7.14%',
      description: 'A spiky companion—just for style.'
    },
    {
      name: 'Kiwi',
      image: '/images/pets/Kiwi.webp',
      ability: 'Increases XP gained from harvesting exotic fruits',
      hatchChance: '7.14%',
      description: 'Small but mighty—levels you up faster with exotic harvests.'
    }
  ],
    legendary: [
    {
      name: 'Cow',
      image: '/images/pets/Cow.webp',
      ability: 'Passively increases growth rate of nearby crops by 12%',
      hatchChance: '7.14%',
      description: 'A helpful farm companion that makes nearby crops grow faster.'
    },
    {
      name: 'Polar Bear',
      image: '/images/pets/Bearbeee1.webp',
      ability: 'Every 90 s, has a 10% chance to apply Chilled or Frozen mutation',
      hatchChance: '7.14%',
      description: 'Applies frosty mutations to crops periodically.'
    },
    {
      name: 'Sea Otter',
      image: '/images/pets/Sea_Otter.webp',
      ability: 'Sprays water every 30 s to accelerate growth of the nearest crop',
      hatchChance: '7.14%',
      description: 'Hydrates your plants, helping them grow faster.'
    },
    {
      name: 'Silver Monkey',
      image: '/images/pets/Silvermonkey.webp',
      ability: '8% chance to refund fruit when selling (also refunds the seed)',
      hatchChance: '7.14%',
      description: 'A better Monkey that sometimes refunds both fruit and seed.'
    },
    {
      name: 'Turtle',
      image: '/images/pets/Turtle_icon.webp',
      ability: 'Sprinklers last 20% longer',
      hatchChance: '7.14%',
      description: 'Boosts sprinkler efficiency to keep crops moist longer.'
    },
    {
      name: 'Tarantula Hawk',
      image: '/images/pets/The_Tarantula_Hawk.webp',
      ability: 'Stings a random pet every 5 min (advancing its cooldown); pollinates a fruit every 25 min',
      hatchChance: '7.14%',
      description: 'A dangerous wasp that helps and harms—boosts cooldowns and pollinates.'
    },
    {
      name: 'Moth',
      image: '/images/pets/Moth.webp',
      ability: 'Every 13 min, sings to a random pet, fully restoring its hunger',
      hatchChance: '7.14%',
      description: 'Cares for your pets by restoring their hunger over time.'
    },
    {
      name: 'Moon Cat',
      image: '/images/pets/Moon_Cat.webp',
      ability: 'Naps every 60 s for 20 s; boosts nearby fruits’ growth ×1.51 and +6.1% stay chance for Moon fruits',
      hatchChance: '7.14%',
      description: 'A lunar feline that boosts fruit growth and Moon fruit retention.'
    },
    {
      name: 'Frog',
      image: '/images/pets/FrogV2.webp',
      ability: 'Every 20 min, croaks and instantly grows a random plant by 24h',
      hatchChance: '7.14%',
      description: 'Leaps your crop ahead in growth with its power croak.'
    },
    {
      name: 'Mole',
      image: '/images/pets/Mole.webp',
      ability: 'Every 80 s, digs up random loot: gear, Sheckles, or nothing',
      hatchChance: '7.14%',
      description: 'Burrows underground to find useful gear or currency.'
    }
  ],
    mythical: [
    {
      name: 'Brown Mouse',
      image: '/images/pets/BrownMouse.webp',
      ability: 'Every 8 min, grants +750 XP and increases jump height by 10%',
      hatchChance: '7.14%',
      description: 'A small mouse that boosts XP gain and jump height.'
    },
    {
      name: 'Grey Mouse',
      image: '/images/pets/GreyMouse.webp',
      ability: 'Every 10 min, grants +500 XP and increases movement speed by 10%',
      hatchChance: '7.14%',
      description: 'A speedy mouse that rewards XP over time.'
    },
    {
      name: 'Caterpillar',
      image: '/images/pets/Caterpillar_Icon.webp',
      ability: 'Increases growth rate of leafy crops by 65%',
      hatchChance: '7.14%',
      description: 'Accelerates the growth of leafy plants like Lettuce and Cabbage.'
    },
    {
      name: 'Giant Ant',
      image: '/images/pets/GiantAntImage.webp',
      ability: '10% chance to duplicate harvested fruit',
      hatchChance: '7.14%',
      description: 'Doubles your fruit rewards during harvest.'
    },
    {
      name: 'Red Giant Ant',
      image: '/images/pets/RedGiantAntImage.webp',
      ability: '5% chance to duplicate any fruit; +5% for fruit crops',
      hatchChance: '7.14%',
      description: 'Strong ant with bonus duplication power for fruits.'
    },
    {
      name: 'Praying Mantis',
      image: '/images/pets/PrayingMantis.webp',
      ability: 'Every 80 s, prays for 10 s, increasing nearby crop mutation chance by 50%',
      hatchChance: '7.14%',
      description: 'Summons divine mutation blessings through prayer.'
    },
    {
      name: 'Red Fox',
      image: '/images/pets/RedFox.webp',
      ability: 'Every 10 min, 50% chance to steal a seed from another player’s plot',
      hatchChance: '7.14%',
      description: 'A sneaky fox with seed-thieving instincts.'
    },
    {
      name: 'Snail',
      image: '/images/pets/Snail_Icon.webp',
      ability: '5% chance to drop a seed when harvesting any crop',
      hatchChance: '7.14%',
      description: 'Slow and steady, helps recover seeds from harvests.'
    },
    {
      name: 'Squirrel',
      image: '/images/pets/Squirrel_Icon.webp',
      ability: '2.5% chance to not consume a seed when planting',
      hatchChance: '7.14%',
      description: 'Smart planter that sometimes saves your seeds.'
    }
  ],
    divine: [
    {
      name: 'Dragonfly',
      image: '/images/pets/DragonflyIcon.webp',
      ability: 'Every 5 min, turns a random crop into Gold mutation',
      hatchChance: '1%',
      description: 'A radiant insect that brings the rare Gold mutation.'
    },
    {
      name: 'Disco Bee',
      image: '/images/pets/DiscoBeeIcon.webp',
      ability: '12% chance every 20 min to Disco-mutate nearby fruit',
      hatchChance: '1%',
      description: 'Dances fruit into fabulous Disco mutation.'
    },
    {
      name: 'Queen Bee',
      image: '/images/pets/Queen_Bee.webp',
      ability: 'Every 20 min, pollinates a nearby fruit; every 30 min, refreshes a random pet’s cooldown',
      hatchChance: '1%',
      description: 'Royal bee that both pollinates and resets other pets.'
    },
    {
      name: 'Raccoon',
      image: '/images/pets/Raccoon.webp',
      ability: 'Every 15 min, duplicates 1 fruit from another player’s plot (nearby)',
      hatchChance: '1%',
      description: 'Sneaky raccoon that steals fruit for your gain.'
    },
    {
      name: 'Night Owl',
      image: '/images/pets/Night_Owl_Icon.webp',
      ability: 'Grants +0.2 XP per second to all active pets',
      hatchChance: '1%',
      description: 'An all-seeing bird that steadily boosts your entire squad’s XP.'
    }
  ]
};

const Pets = () => {
  const [activeCategory, setActiveCategory] = useState('common');
  const [searchTerm, setSearchTerm] = useState('');

  const categoryNames = {
    common: 'Common Pets',
    uncommon: 'Uncommon Pets',
    rare: 'Rare Pets',
    legendary: 'Legendary Pets',
    mythical: 'Mythical Pets',
    divine: 'Divine Pets'
  };

  const categoryColors = {
    common: '#8bc34a',
    uncommon: '#4caf50',
    rare: '#2196f3',
    legendary: '#ff9800',
    mythical: '#f44336',
    divine: '#e91e63'
  };

  const filteredPets = pets[activeCategory].filter(pet =>
    pet.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    pet.ability.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPets = Object.values(pets).reduce((sum, category) => sum + category.length, 0);

  return (
    <div className="pets-container">
      <h2>Roblox Grow a Garden Pets Guide</h2>
      <div className="pets-updated">
        Updated: June 26, 2025 - Complete official wiki data ({totalPets} total pets)
      </div>

      <div className="pets-search">
        <input
          type="text"
          placeholder="Search pets by name or ability..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="pets-search-input"
        />
      </div>

      <div className="pets-categories">
        {Object.keys(pets).map(category => (
          <button
            key={category}
            className={`category-btn ${activeCategory === category ? 'active' : ''}`}
            onClick={() => setActiveCategory(category)}
            style={{
              backgroundColor: activeCategory === category ? categoryColors[category] : '#f0f0f0',
              color: activeCategory === category ? 'white' : '#333'
            }}
          >
            {categoryNames[category]}
            <span className="category-count">({pets[category].length})</span>
          </button>
        ))}
      </div>

      <div className="pets-grid">
        {filteredPets.length === 0 ? (
          <div className="no-pets-found">
            No pets found matching "{searchTerm}"
          </div>
        ) : (
          filteredPets.map(pet => (
            <div key={pet.name} className="pet-card" style={{ borderColor: categoryColors[activeCategory] }}>
              <div className="pet-image-container">
                <img
                  src={pet.image}
                  alt={pet.name}
                  className="pet-image"
                  onError={(e) => {
                    e.target.src = '/images/pets/placeholder.png';
                  }}
                />
                <div className="pet-rarity" style={{ backgroundColor: categoryColors[activeCategory] }}>
                  {activeCategory.toUpperCase()}
                </div>
              </div>
              <div className="pet-info">
                <h3 className="pet-name">{pet.name}</h3>
                <p className="pet-description">{pet.description}</p>
                <div className="pet-ability">
                  <strong>Ability:</strong> {pet.ability}
                </div>
                <div className="pet-hatch-chance">
                  <strong>Hatch Chance:</strong> 
                  <span className="hatch-percentage" style={{ color: categoryColors[activeCategory] }}>
                    {pet.hatchChance}
                  </span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      <div className="pets-stats">
        <h3>Pet Collection Statistics</h3>
        <div className="stats-grid">
          {Object.keys(pets).map(category => (
            <div key={category} className="stat-card" style={{ borderLeftColor: categoryColors[category] }}>
              <div className="stat-category">{categoryNames[category]}</div>
              <div className="stat-count">{pets[category].length} pets</div>
              <div className="stat-total-chance">
                Total Hatch: {pets[category].reduce((sum, pet) => 
                  sum + parseFloat(pet.hatchChance.replace('%', '')), 0
                ).toFixed(1)}%
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Pets;